module.exports = __webpack_public_path__ + "static/img/manufacturer_256.1bef6cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/manufacturer_256.png
// module id = jZwC
// module chunks = 0